export function getCurrentSizeInEM(window) {
  const bodyFontSize = parseInt(window.getComputedStyle(document.body).fontSize);
  return window.innerWidth / bodyFontSize;
}
